export { default as BCBSIL } from "./favicon-il.ico";
export { default as BCBSTX } from "./favicon-tx.ico";
export { default as BCBSNM } from "./favicon-nm.ico";
export { default as BCBSOK } from "./favicon-ok.ico";
export { default as BCBSMT } from "./favicon-mt.ico";
